import { doGet } from './FetchWrapper';

export const get = () => {
    return doGet(`/api/?event=requestUser.get`);
};


